import React, { useEffect } from 'react';

import Headersection from './Headersection'
import Whyethosflo from './Whyethosflo'
import Howitworks from './Howitworks'
import Helpfulresources from './Helpfulresources'
import Dataprivacy from './Dataprivacy'
import Firstpage from './Firstpage'
// import Aboutus from './Aboutus'
import Footer from './Footer'
// import Assesmentprocessflow from './Assesmentprocessflow'
import Assessmentmodules from './Assessmentmodules'
// import Benefitsforrequestingorganization from './Benefitsforrequestingorganization'
// import Benefitsforassessees from './Benefitsforassessees'
// import Globallignment from './Globallignment'
// import Expertsupport from './Expertsupport'
// import Assessmenttimeline from './Assessmenttimeline'
import Frequentlyaskedquestions from './Frequentlyaskedquestions'
// import Getstartedwithethosflo from './Getstartedwithethosflo'
// import HowEthosflowasBorn from "./HowEthosflowasBorn"
// import Howitworkspopup from "./Howitworkspopup"
// import Assesementpopup from "./Assesementpopup"
// import Expertsupport from "./Expertsupport"
// import Usecase from './Usecase'

const Page2 = () => {
  useEffect(() => {
    if (sessionStorage.getItem("fromLogin") === "true") {
      sessionStorage.removeItem("fromLogin");


      window.history.replaceState(null, "", "/");

      window.location.reload();
    }
  }, []);


  return (
    <>
    <Headersection />
    <Firstpage />
    {/* <Aboutus /> */}
    <Whyethosflo />
    <Assessmentmodules />
    <Howitworks />
   
    {/* <Assesmentprocessflow/> */}
    <Helpfulresources />
    <Dataprivacy />
    
    {/* <Benefitsforrequestingorganization />
    <Benefitsforassessees /> */}
    {/* <Globallignment /> */}
  
    {/* <Assessmenttimeline /> */}
    <Frequentlyaskedquestions />
      {/* <Expertsupport />
      <Usecase />
    <Getstartedwithethosflo /> */}
    {/* <HowEthosflowasBorn />
    <Howitworkspopup />
    <Assesementpopup /> */}



     

    <Footer />
    

    
    
    
    </>
  )
}

export default Page2